import { Skeleton, Tooltip } from "@findemdev/maui";
import { StyledAvatar } from "../../../../AppHeader/Header.styled";
import { decodeString, getInitials } from "@findemdev/findem-helpers";
import { IFetchAllUsersResponse } from "../../../../../types/users";
import useProfileColor from "../../../hooks/useProfileColors";

interface IOwnerProps {
  isPending: boolean;
  credentialOwnerUid: string;
  allUsers: IFetchAllUsersResponse | undefined;
}

const Owner = ({ isPending, credentialOwnerUid, allUsers }: IOwnerProps) => {

  if (isPending || !allUsers) {
    return <Skeleton.Button style={{ width: 100 }} active size="small" />;
  }

  const user = allUsers.users.find(user => user._id === credentialOwnerUid);

  const userColor = useProfileColor(user?.local?.name ?? "");

  return <Tooltip
    title={user?.local?.name ?? "Unknown User"}
  >
    <StyledAvatar
      $bgColor={userColor}
    >
      {getInitials(decodeString(user?.local?.name ?? ""))}
    </StyledAvatar>
  </Tooltip>
};

export default Owner;